import { render, staticRenderFns } from "./OrderContent.vue?vue&type=template&id=f7f1202c"
import script from "./OrderContent.vue?vue&type=script&lang=js"
export * from "./OrderContent.vue?vue&type=script&lang=js"
import style0 from "./OrderContent.vue?vue&type=style&index=0&id=f7f1202c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports